import React from "react";
import "../css/Version.css";

const VersionInfo = () => {
  return (
    <div className="version-info">
      <p>Version: 1.3.9</p>
    </div>
  );
};

export default VersionInfo;
